import {
  CreateBillToCommodityRequest,
  UpdateBillToCommodityRequest
} from "../api/system/billToCommodities";

export class EditBillToCommodityModel {
  id: number = null;
  commodityCode: string;
  billTo: string;
  visible: boolean = true;
  saving: boolean = false;

  get isNew(): boolean {
    return !this.id;
  }

  toCreateRequest(): CreateBillToCommodityRequest {
    return { billTo: this.billTo, commodityCode: this.commodityCode };
  }

  toUpdateRequest(): UpdateBillToCommodityRequest {
    return { id: this.id, billTo: this.billTo, commodityCode: this.commodityCode };
  }
}
